import { EmployeeModel } from 'api-hooks/employee';
import { GenderTypeEnum } from 'common/constants/enum';
import React from 'react';

import { EmployeeFormType } from '../components/form-type';

export default function useGetDefaultValues(
  employee?: EmployeeModel,
): EmployeeFormType {
  return React.useMemo(() => {
    return {
      address: employee?.address || '',
      code: employee?.code || '',
      gender: employee?.gender || GenderTypeEnum.Male,
      jobLevel: employee?.jobLevel || '',
      joinedAt: employee?.joinedAt || null,
      name: employee?.name || '',
      password: '',
      passwordConfirmation: '',
      phone: employee?.phone || '',
      phone_2: employee?.phone_2 || '',
      roles: (employee?.roles || []).map((role) => {
        return {
          id: role.id,
          label: role.name,
        };
      }),
      username: employee?.username || '',
      employee,
    };
  }, [employee]);
}
